import { section } from "@/neon";
import { on, emit } from "@/neon/events";

import navigation from "@/components/navigation";
import quickSearch from "@/components/quickSearch";
import disclosure from "@/components/disclosure";
import menu from "@/lib/drawer-menu";

const selectors = {
  jsCartCount: ".js-cart-count",
  jsCartToggle: ".js-cart-drawer-toggle",
  cartCountInner: ".quick-cart__indicator-inner",
  currencySelector: ".header__icon--currency",
  languageSelector: ".header__icon--language",
  disclosure: "[data-disclosure]",
  drawerMenu: "[data-drawer-menu]",
};

section("header", {
  crossBorder: {},

  onLoad() {
    const drawerMenu = document.querySelector(selectors.drawerMenu);
    this.menu = menu(drawerMenu);
    this.menuButton = this.container.querySelector("#mobile-nav");
    const cartCount = this.container.querySelector(selectors.jsCartCount);
    const cartToggle = this.container.querySelector(selectors.jsCartToggle);

    this.navigation = navigation(this.container);

    this.navigationCloseHandler = on("navitem:closeOthers", () => {
      this.navigation.closeAll();
    });

    this.menuButton.addEventListener("click", this._openMenu.bind(this));

    on("cart:updated", state => {
      const cartCountInner = cartCount.querySelector(selectors.cartCountInner);

      cartCountInner.innerHTML = state.cart.item_count;
      cartCount.classList.toggle("hidden", !state.cart.item_count);
    });

    cartToggle.addEventListener("click", e => {
      e.preventDefault();

      emit("cart:toggle", state => {
        return {
          cartOpen: !state.cartOpen,
        };
      });
    });

    on("cart:open", ({ cartOpen }) => {
      cartToggle.setAttribute("aria-expanded", true);
    });

    on("cart:close", ({ cartOpen }) => {
      cartToggle.setAttribute("aria-expanded", false);
    });

    on("section:first-full-height", () =>
      this.container.classList.add("first-section-is-full-width")
    );

    this.quickSearch = this.container.querySelector(".quick-search");
    this.predictiveSearch = quickSearch({
      container: this.quickSearch,
    });

    this._initDisclosure();
  },

  _openMenu(e) {
    e.preventDefault();

    this.menu.open();
  },

  _showHeaderOverlay(event) {
    if (event.target.ariaExpanded === "true") {
      emit("headerOverlay:show");
    } else {
      emit("headerOverlay:hide");
    }
  },

  _initDisclosure() {
    const languageSelectorContainer = this.container.querySelector(
      selectors.languageSelector
    );
    const currencySelectorContainer = this.container.querySelector(
      selectors.currencySelector
    );

    if (languageSelectorContainer) {
      this.languageTrigger = languageSelectorContainer.querySelector(
        selectors.disclosure
      );

      const { disclosure: d } = this.languageTrigger.dataset;
      this.crossBorder[d] = disclosure(
        this.languageTrigger,
        languageSelectorContainer
      );

      this.languageTrigger.addEventListener("click", this._showHeaderOverlay);
    }

    if (currencySelectorContainer) {
      this.currencyTrigger = currencySelectorContainer.querySelector(
        selectors.disclosure
      );

      const { disclosure: d } = this.currencyTrigger.dataset;
      this.crossBorder[d] = disclosure(
        this.currencyTrigger,
        currencySelectorContainer
      );

      this.currencyTrigger.addEventListener("click", this._showHeaderOverlay);
    }
  },

  onSelect() {
    emit("sticky-header:reload", () => {});
  },

  onBlockSelect({ target: navigation }) {},

  onUnload() {
    this.menu.destroy();
    this.predictiveSearch.unload();
    this.navigation.unload();
    this.navigationCloseHandler();

    this.currencyTrigger &&
      this.currencyTrigger.removeEventListener(
        "click",
        this._showHeaderOverlay
      );
    this.languageTrigger &&
      this.languageTrigger.removeEventListener(
        "click",
        this._showHeaderOverlay
      );

    Object.keys(this.crossBorder).forEach(t => {
      this.crossBorder[t].unload();
    });
  },
});
